import React from 'react'
import { FloraButton, FloraButtonProps } from '@grupoboticario/flora-react'
import { styled, FloraVariants, forwardRef } from '@grupoboticario/flora-react-system'

const StyledTableCellButton = styled(
  (props: FloraButtonProps) => (
    <FloraButton
      size="small"
      hierarchy="tertiary"
      css={{ height: '$8', width: '$8', color: 'inherit' }}
      {...props}
    />
  ),
  {},
)

export type TableCellButtonProps = FloraButtonProps & FloraVariants<typeof StyledTableCellButton>

export const TableCellButton = forwardRef<'div', TableCellButtonProps>((props, forwardedRef) => {
  return <StyledTableCellButton ref={forwardedRef} data-flora="table-cell-button" {...props} />
})
